// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CheckboxUncheckedComponent} from './CheckboxUnchecked.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCheckboxUnchecked = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CheckboxUncheckedComponent/>
  </Icon>
));
